import Socket from '@/utils/socket'
import type { memberListInterface } from '@/types/apiType/roomType'
import type {
  sendInterface,
  responseInterface
} from '@/types/viewsType/socketType'
import type { giftSendResponseInterface } from '@/types/apiType/giftType'

export const useSocketStore = defineStore({
  id: 'socket',
  state: () => ({
    inSocket: {} as Socket<sendInterface, responseInterface>, // Socket实例
    isFirstSocketLogin: false as boolean, // socket 是否首次登录成功， 用来给 arrivedLogin 使用
    isSocketLogin: false as boolean, // socket 是否登录成功
    isReconnect: false as boolean, // 是否在重连
    // 房间部分rListInterf
    personRoomMemberInfo: {} as memberListInterface, // 加入房间后得的个人信息
    isEnterRoom: false as boolean, // 是否进入房间
    socketOnlineNum: 0 // socket 在线人数
  }),
  actions: {
    /** 设置是否进入房间 */
    setIsEnterRoom(value: boolean) {
      this.isEnterRoom = value
    },
    // 初始化
    init() {
      console.log('socket => 开始初始化')
      const runtimeConfig = useRuntimeConfig()
      this.destroy()
      this.isReconnect = false
      this.socketOnlineNum = 0
      this.inSocket = new Socket<sendInterface, responseInterface>({
        url: runtimeConfig.public.socketUrl,
        debug: true,
        openCb: this.onLogin,
        heartCb: this.onHeart,
        messageCb: this.onMsg,
        reconnectCb: this.onReconnet,
        closeCb: this.onClase,
        errorCb: this.onError
      })
    },
    // 销毁
    destroy() {
      // 有才销毁
      if (this.inSocket && this.inSocket.destroy) {
        this.inSocket.destroy()
        this.isFirstSocketLogin = false
        this.isSocketLogin = false
        this.isReconnect = false
        this.personRoomMemberInfo = {
          avatar: '',
          uid: 0,
          nick: ''
        }
        this.setIsEnterRoom(false)
        this.socketOnlineNum = 0
      }
    },
    // 收到消息回调
    onMsg(res) {
      if ((res.res_data && res.res_data.errno === 0) || res.req_data) {
        this.onSuccessMsg(res)
      } else {
        this.onFailMsg(res)
      }
    },
    // 成功回调
    onSuccessMsg(res) {
      const router = useRouter()
      const { id, route, res_data, req_data } = res
      const data = res_data ? res_data.data : req_data // 请求和返回不一样的data字段
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      const micApplyStore = useMicApplyStore()
      const rocketStore = useRocketStore()
      switch (route) {
        case socketResponseRoute.sendMessageReport: // 房间里礼物暂时动画监听，游戏中奖消息
          this.onSendMessageReport(data)
          break
        case socketResponseRoute.matchSuccess: // 电话匹配
          this.onMatchSuccess(data)
          break
        case socketResponseRoute.kickoff: // 踢出登录
          if (!roomStore.isApp) {
            publicStore.resetLogin({
              msg: 'socket-kickoff',
              type: 'socket-kickoff'
            })
          }
          break
        case socketResponseRoute.ChatRoomMemberKicked: // 被主播踢出
          if (roomStore.isApp) {
            // IOS执行退出房间
            AppNative.appFun(AppNative.iosNeedMessageFun.roomMemberKicked)
          } else {
            showToast(data.reason_msg)
            roomStore.kickedOutRoom()
          }
          break
        case socketRequestRoute.login: // 登录成功
          this.isFirstSocketLogin = true
          this.isSocketLogin = true
          this.isReconnect = false
          break
        case socketResponseRoute.sendTextReport: // 房间收到文本信息
          this.onSendTextReport(id, data)
          break
        case socketResponseRoute.chatRoomMemberIn: // 房间成员进入房间
          this.onChatRoomMemberIn(id, data)
          break
        case socketResponseRoute.chatRoomMemberExit: // 房间成员退出房间
          this.onChatRoomMemberExit(data)
          break
        case socketResponseRoute.QueueMemberUpdateNotice: // 麦位或主播位成员列表发生变化
          this.onQueueMemberUpdateNotice(data)
          break
        case socketRequestRoute.enterWithOpenChatRoom: // 进入房间
          this.onEnterWithOpenChatRoom(data)
          break
        case socketResponseRoute.roomMicCharmPush: // 麦位魅力值推送通知
          this.onRoomMicCharmPush(data)
          break
        case socketRequestRoute.updateQueue: // 上麦回调
          this.onUpdateQueue(data)
          break
        case socketResponseRoute.QueueMicUpdateNotice: // 麦位状态更新
          this.onQueueMicUpdateNotice(data)
          break
        case socketResponseRoute.ChatRoomManagerAdd: // 房间内设置管理员通知
          this.onChatRoomManagerAdd(data)
          break
        case socketResponseRoute.ChatRoomManagerRemove: // 房间内移除管理员通知
          this.onChatRoomManagerRemove(data)
          break
        case socketResponseRoute.ChatRoomInfoUpdated: // 房间信息更新 麦位数量更新
          roomStore.setSocketRoomInfo('update', data.room_info)
          break
        case socketResponseRoute.roomReceiveSum: //视屏房收益通知
          roomStore.setSocketRoomInfoKeyValue(
            'receiveSum',
            data.custom.data.receiveSum as number
          )
          if (data.custom.data.receiveGold) {
            roomStore.setSocketRoomInfoKeyValue(
              'receiveGold',
              data.custom.data.receiveGold as number
            )
          }
          break
        case socketResponseRoute.multiRoomMicApply: // 排麦
          micApplyStore.onMultiRoomMicApply(data)
          break
        case socketResponseRoute.multiRoomMicCancel: // 排麦
          micApplyStore.onMultiRoomMicCancel(data)
          break
        case socketResponseRoute.multiRoomMicAgree: // 排麦
          micApplyStore.onMultiRoomMicAgree(data)
          break
        case socketResponseRoute.multiRoomMicReject: // 排麦
          micApplyStore.onMultiRoomMicReject(data)
          break
        case socketResponseRoute.roomRocketDiamond: // 炸弹流水
          rocketStore.onRoomRocketDiamond(data)
          break
        case socketResponseRoute.roomRocketBlowUp: // 炸弹爆炸
          rocketStore.onRoomRocketBlowUp(data)
          break
        case socketResponseRoute.roomRocketDel: // 炸弹重置
          rocketStore.onRoomRocketDel(data)
          break
        case socketResponseRoute.roomRocketReward: // 炸弹奖励
          rocketStore.onRoomRocketReward(data)
          break
        case socketResponseRoute.roomLevelMicStyleChange: // 房间麦位样式更新
          roomStore.getRoomLevelInfo()
          break
        default:
          // 其他请求
          break
      }
    },
    // 失败回调
    onFailMsg(res) {
      const { route, res_data, req_data } = res
      const data = res_data ? res_data : req_data // 请求和返回不一样的data字段
      const publicStore = usePublicStore()
      const roomStore = useRoomStore()
      showToast(data.errmsg)
      switch (route) {
        // 进入房间
        case socketRequestRoute.enterWithOpenChatRoom:
          if (res_data.errno === 100202) {
            // 被踢出房间
            if (roomStore.isApp) {
              // IOS执行退出房间
              AppNative.appFun(AppNative.iosNeedMessageFun.roomMemberKicked)
            } else {
              roomStore.kickedOutRoom()
            }
          }
          // 需要输入房间密码
          if (res_data.errno === 100207) {
            roomStore.setRoomPasswordDialogConfig({ isShow: true })
          }
          break
        // im 登录验证失败
        case socketRequestRoute.login:
          if (res_data.errno === 100100) {
            // 重置登录
            if (!roomStore.isApp) {
              publicStore.resetLogin({
                msg: 'socket- res_data.errno === 100100',
                type: 'socket'
              })
            }
          }
          break
        default:
          // 其他请求
          break
      }
    },
    // 房间里礼物暂时动画监听
    onSendMessageReport(data) {
      const roomStore = useRoomStore()
      const audioStore = useAudioStore()
      const animationStore = useAnimationStore()
      const micEmojiStore = useMicEmojiStore()

      if (typeof data.custom === 'string') {
        data.custom = JSON.parse(data.custom)
      }

      // 房间侧边动画列表条件
      if (
        (data.custom && data.custom.first === 3 && data.custom.second === 31) ||
        (data.custom && data.custom.first === 12 && data.custom.second === 1)
      ) {
        animationStore.onGiftSend(data.custom.data)

        // 房间公屏礼物信息
        roomStore.updateChatList('put', {
          id: data.timestamp,
          uid: data.custom.data.uid,
          type: constant.ROOM_CHAT_TYPE.CHAT_GIFT,
          content: '',
          nick: data.custom.data.nick, // 送礼人
          targetNick: data.custom.data.targetNick, // 收礼人
          targetUid: data.custom.data.targetUid || '', // 收礼人id
          targetAvatar: data.custom.data.targetAvatar, // 收礼人头像
          targetUids: data.custom.data.targetUids, // 多人收礼人

          giftInfo: data.custom.data.giftInfo,
          giftId: data.custom.data.giftId, // 礼物id
          giftName: data.custom.data.giftName, // 礼物每次
          giftPic: data.custom.data.giftPic, // 礼物图片
          giftNum: data.custom.data.giftNum
        })
      }
      // 幸运送礼翻倍 倍率要大于等于20才显示
      if (
        data.custom &&
        data.custom.first === 34 &&
        data.custom.second === 1 &&
        data.custom.data.proportion >= 20
      ) {
        // 房间消息
        roomStore.updateChatList('put', {
          id: data.timestamp,
          content: '',
          type: constant.ROOM_CHAT_TYPE.LUCK_REBATE,
          nick: data.custom.data.nick,
          outputGold: data.custom.data.outputGold,
          proportion: data.custom.data.proportion,
          uid: data.custom.data.uid
        })
      }
      // 游戏中奖者
      if (
        data.custom &&
        data.custom.first === 36 &&
        data.custom.second === 36
      ) {
        roomStore.updateChatList('put', {
          id: data.timestamp,
          content: '',
          gameWinningInfoArr: data.custom.data.content,
          type: constant.ROOM_CHAT_TYPE.GAME
        })
      }
      // 游戏返利
      if (
        data.custom &&
        data.custom.first === 36 &&
        data.custom.second === 190
      ) {
        roomStore.updateChatList('put', {
          id: data.timestamp,
          content: '',
          gameWinningInfoArr: data.custom.data.content,
          type: constant.ROOM_CHAT_TYPE.GAME,
          jumpUrl: data.custom.data.jumpUrl,
          gameIcon: data.custom.data.icon,
          gameName: data.custom.data.name
        })
      }
      // 语音房邀请上麦通知
      if (
        data.custom &&
        data.custom.first === 8 &&
        data.custom.second === 81 &&
        data.custom.data
      ) {
        audioStore.onInviteMessage(data.custom.data)
      }
      // html提示
      if (
        data.custom &&
        data.custom.first === 10000 &&
        (data.custom.second === 0 || data.custom.second === 1)
      ) {
        setTimeout(() => {
          roomStore.updateChatList('put', {
            id: data.timestamp,
            content: data.custom.data.html,
            type: constant.ROOM_CHAT_TYPE.PROMPT_HTML
          })
        }, 200)
      }
      // 发送麦位表情通知
      if (data.custom && data.custom.first === 9 && data.custom.second === 91) {
        micEmojiStore.onUserSendMicEmoji(data.custom.data)
      }
      // CP上麦
      if (data.custom && data.custom.first === 37 && data.custom.second === 1) {
        const obj = {
          cpGradles: JSON.parse(data.custom.data.cpGradles) as number[],
          ownerAvatar: data.custom.data.ownerAvatar as string,
          ownerNick: data.custom.data.ownerNick as string,
          ownerUid: data.custom.data.ownerUid as string,
          targetAvatars: JSON.parse(data.custom.data.targetAvatars) as string[],
          targetNicks: JSON.parse(data.custom.data.targetNicks) as string[],
          targetUids: JSON.parse(data.custom.data.targetUids) as string[]
        }
        // 横幅
        animationStore.setBannerCPMic('push', obj)
        // 房间公屏
        roomStore.updateChatList('put', {
          bannerCPMic: obj,
          type: constant.ROOM_CHAT_TYPE.CP_MIC,
          content: ''
        })
      }
      // 等级提升
      if (
        data.custom &&
        data.custom.first === 170 &&
        data.custom.second === 170
      ) {
        animationStore.setBannerLevelUp('push', {
          ...data.custom.data,
          roomId: data.room_id
        })
      }
    },
    /**
     * on 通话接听接受
     * 通话场景
     * type: 1:收到视频呼叫;2:关闭通话;3:钻石不足以维持一分钟;4:匹配成功,或者说女生被强制拉入1v1（就是女生没有在匹配也会收到这条im）;5:对方接受呼叫;6:体验券将要结束，7：对方拒绝接听，8：挂断;
     *       9: 视频通话（人脸检测通知）;10:视频通话，正式开始计费;11: 新版本余额不足，兼容处理（v1.0.1.2）;
     *       12:男生匹配成功im;13:收到匹配弹窗im,弹窗让女生选择是否接受;14:对方已在通话中;15:兜底策略，怕呼叫收不到弹窗，这个是确认弹窗，16：女生匹配取消
     * 目前H5暂时不做接听功能
     * */
    onMatchSuccess(data) {
      const callStore = useCallStore()
      const custom = JSON.parse(data.custom.data)
      switch (custom.type) {
        case 1: // 收到视频呼叫
          callStore.onCallAccept(custom)
          break
        case 2: // 通话关闭
          if (!custom.time || custom.time <= 0) {
            callStore.onCallClose(custom.msg)
          }
          break
        case 3: // 拨打方钻石不足做提示
          this.onCallRoomNotEnoughDiamondTips(custom.msg)
          break
        case 4: // 男生匹配成功
          callStore.onCallSuccess(custom.matchUid, 2, 1)
          break
        case 5: // 对方接听
          callStore.onCallSuccess(custom.acceptUid, 1, 1)
          break
        case 7: // 对方拒绝接听
          callStore.onCallRejected(custom)
          break
        case 8: // 通话挂断
          if (!custom.time || custom.time <= 0) {
            callStore.onCallHang(custom.msg)
          }
          break
        case 10: // 视频通话，正式开始计费
          // callStore.onStartBilling()
          callStore.setCallId(custom.callId as number)
          break
        case 12: // 男生匹配成功
          callStore.onCallSuccess(custom.acceptUid, 2, 1)
          break
        default:
          break
      }
    },
    // 同步等待是否登录
    arrivedLogin() {
      return new Promise((resolve, reject) => {
        if (this.isFirstSocketLogin) {
          resolve(this.isSocketLogin)
        }
        const interval = 20
        let timeOut = 4000
        const timer = setInterval(() => {
          timeOut -= interval
          if (timeOut < 1) {
            clearInterval(timer)
            reject('catching timed out')
          }
          if (this.isFirstSocketLogin) {
            clearInterval(timer)
            resolve(true)
          }
        }, interval)
      })
    },
    /**
     * send 发送消息
     * @param {string} content 文本
     */
    sendText(content: string) {
      if (!content.trim()) return Promise.reject(false)
      const roomStore = useRoomStore()
      const callStore = useCallStore()
      const req_data = {
        room_id: roomStore.roomId,
        member: JSON.stringify(this.personRoomMemberInfo),
        content,
        module_id: callStore.callId || 0 // 1v1的时候 加个字段 moduleId, 其实就是callId,其他场景默认0
      }
      return this.privateSend({
        route: socketRequestRoute.sendText,
        req_data
      })
    },
    /**
     * send 发送sendMessage，给客户端移除遮罩层, 上麦邀请
     */
    sendMessage(req_data) {
      if (!this.isEnterRoom) return // 进房后才正常执行
      return this.privateSend(
        {
          route: socketRequestRoute.sendMessage,
          req_data
        },
        true
      )
    },
    // send 进入房间
    /**
     *  room_type -1:'',3:语音房,5:'',6:视频房,7:游戏房,8：多人视频房,10:1v1视频聊天
     * **/
    snedEnterWithOpenChatRoom(info: {
      uid: number | string
      type: 3 | 6 | 10
      pwd?: string | null
      avatar?: string
      title?: string
    }) {
      this.setIsEnterRoom(false)
      return this.privateSend({
        route: socketRequestRoute.enterWithOpenChatRoom,
        req_data: {
          room_uid: info.uid, // 房主uid
          room_type: info.type, // 房间类型
          room_pwd: info.pwd || null, //房间密码
          avatar: info.avatar || '',
          title: info.title || '',
          is_can_connect_mic: 1, // 是否开启连麦
          ticket: localStorage.getItem('ticket') as string,
          seats: 4,
          reconnect: this.isReconnect ? 1 : 0 //是否重连 1 0
        }
      })
    },
    // send 退出房间
    // 退出房间初始化
    sendExitChatRoom() {
      const roomStore = useRoomStore()
      this.setIsEnterRoom(false)
      this.personRoomMemberInfo = { uid: 0, avatar: '', nick: '' }
      this.socketOnlineNum = 0
      roomStore.setIsHostLive(false)
      this.privateSend({
        route: socketRequestRoute.exitChatRoom,
        req_data: {
          room_id: roomStore.roomId
        }
      })
    },
    /**
     * 统一使用发送
     * @param obj : 发送信息，
     * @param isNeedRoom  是否判断进房
     *
     * 调这个区分App使用和web使用
     * */
    privateSend(obj: sendInterface, isNeedRoom?: boolean) {
      const i18n = useNuxtApp().$i18n
      const roomStore = useRoomStore()
      // app
      if (roomStore.isApp) {
        console.log('socket => privateSend', obj)
        // App代发送消息
        AppNative.appFun(
          AppNative.iosNeedMessageFun.socketSend,
          JSON.stringify(obj)
        )
        return Promise.resolve(true)
      }

      // web
      return this.arrivedLogin().then(() => {
        // 判断当前网络
        if (!navigator.onLine) {
          showToast(i18n.t('public.noInternetTips'))
          return Promise.reject('The network is currently unavailable.')
        }

        // isNeedRoom 为 true 就需要判断是否进房成功
        if (isNeedRoom && !this.isEnterRoom) {
          return Promise.reject(i18n.t('public.noRoomTips'))
        }

        // 判断是否登录成功，登录成功才发送消息
        if (!this.isSocketLogin) {
          showToast(i18n.t('public.connectTips'))
          return Promise.reject('Reconnecting or logging in, please wait.')
        }
        if (
          this.inSocket.options.debug &&
          obj.route !== socketRequestRoute.heartbeat
        ) {
          console.log('socket => send:', obj)
        }
        return this.inSocket.send(obj)
      })
    },
    // on 部分
    // on 进入房间
    onEnterWithOpenChatRoom(data) {
      const audioStore = useAudioStore()
      const roomStore = useRoomStore()

      this.socketOnlineNum = 0
      this.personRoomMemberInfo = data.member
      // 设置进房成功
      this.setIsEnterRoom(true)
      // 初始化语音房麦位等信息
      if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
        audioStore.initData(data)
      }

      roomStore.onEnterRoomSuccess(data)
    },
    // on 登录回调
    onLogin() {
      this.isReconnect = false
      this.inSocket.send({
        route: socketRequestRoute.login,
        req_data: {
          page_name: 5,
          uid: localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0,
          ticket: localStorage.getItem('ticket') as string
        }
      })
    },
    // on 心跳回调
    onHeart() {
      const roomStore = useRoomStore()
      this.privateSend({
        route: socketRequestRoute.heartbeat,
        req_data: {
          uid: localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0,
          room_id: roomStore.roomId,
          roomUid: roomStore.roomUid
        }
      })
    },
    // on 重连监听
    onReconnet() {
      this.isReconnect = true
      this.isSocketLogin = false
    },
    /**
     * on 关闭
     */
    onClase(e) {
      console.log('socket => onClose', e, JSON.stringify(e))
      console.log('socket => onClose isTrusted:', e.isTrusted)
      console.log('socket => onClose Code:', e.code) // 查看 code 是否为空
      console.log('socket => onClose Reason:', e.reason) // 查看 reason 是否为空
      console.log('socket => onClose Was clean:', e.wasClean) // 查看 wasClean 是否为空
      this.isSocketLogin = false
    },
    /**
     * on 关闭
     */
    onError(e) {
      console.log('socket => onError', e)
      this.isSocketLogin = false
    },
    // on 房间收到文本信息
    onSendTextReport(id, data) {
      const roomStore = useRoomStore()
      const member =
        typeof data.member === 'string' ? JSON.parse(data.member) : data.member
      roomStore.updateChatList('put', {
        id: `${id}${member.uid}`, // 唯一值
        nick: member.nick,
        uid: member.uid || member.account,
        content: data.content,
        type: constant.ROOM_CHAT_TYPE.CHAT_TEXT,
        translateLoading: false,
        translateContent: '',
        member
      })
      // 判断是否有弹幕
      if (data.barrageMsg) {
        roomStore.setBarrageInfo({
          id,
          nick: member.nick,
          avatar: member.avatar,
          barrageMsg: data.barrageMsg
        })
      }
    },
    // 麦位或主播位成员列表发生变化
    onQueueMemberUpdateNotice(data) {
      /*
        key 麦位排序
        min_info 麦位信息
        value 麦位用户信息
        type 1上麦 2下麦
        connect_mic_type 0语音 1视频 2invalid 3PK
        */
      const roomStore = useRoomStore()
      const audioStore = useAudioStore()

      if (data.type === 1) {
        // 更新在线成员
        roomStore.getMemberList(true)
      }

      // 语音房
      if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
        audioStore.onQueueMemberUpdateNotice(data)
      }
    },
    // on 房间成员退出房间
    onChatRoomMemberExit(data) {
      const roomStore = useRoomStore()
      this.socketOnlineNum = data.online_num
      roomStore.getMemberList()
    },
    // on 房间成员进入房间
    onChatRoomMemberIn(id, data) {
      const roomStore = useRoomStore()
      const animationStore = useAnimationStore()
      this.socketOnlineNum = data.online_num
      roomStore.getMemberList()
      roomStore.updateChatList('put', {
        id: id,
        nick: data.member.nick,
        uid: data.member.uid,
        content: '',
        type: constant.ROOM_CHAT_TYPE.ENTER_ROOM,
        member: data.member
      })
      // 添加进房特效
      if (data.member.carVideoUrl || data.member.car_url) {
        // 和礼物特效共用数组
        animationStore.setEffectCar({
          carVideoUrl: data.member.carVideoUrl || '',
          carUrl: data.member.car_url || '',
          customizeCar: data.member.customizeCar
        } as giftSendResponseInterface)
      }

      /**
       * 添加进房动画到横幅
       * vip 或 财富等级>=10 才有进房横幅
       */
      if (
        (data.member.vip && data.member.vip.vipGrade > 0) ||
        data.member.exper_level >= 10
      ) {
        animationStore.setBannerEnterRooms('push', data.member)
      }
    },
    // 视频通话钻石不足提示
    onCallRoomNotEnoughDiamondTips(msg: string) {
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      roomStore.updateChatList('put', {
        content: msg,
        type: constant.ROOM_CHAT_TYPE.PROMPT_TEXT
      })
      publicStore.setShowRechargePopup(true)
    },
    // 语音房 麦位魅力值推送通知
    onRoomMicCharmPush(data) {
      const audioStore = useAudioStore()
      audioStore.onRoomMicCharmPush(data)
    },
    /** 语音房 上麦成功回调  */
    onUpdateQueue(data) {
      const audioStore = useAudioStore()
      audioStore.setRtcInfoMic(data.rtcInfo)
    },
    // 语音房 麦位状态更新
    onQueueMicUpdateNotice(data) {
      const audioStore = useAudioStore()
      audioStore.onQueueMicUpdateNotice(data)
    },
    //语音房 设置管理员通知
    onChatRoomManagerAdd(data) {
      const audioStore = useAudioStore()
      audioStore.onChatRoomManagerAdd(data)
    },
    //语音房 移除管理员通知
    onChatRoomManagerRemove(data) {
      const audioStore = useAudioStore()
      audioStore.onChatRoomManagerRemove(data)
    }
  },
  persist: {
    key: 'socketStore',
    paths: ['inSocket']
  }
})
